module.exports = __webpack_public_path__ + "img/idcard1.e6a9e3b4.png";